import "./Bachelor.scss";
import { useHistory } from "react-router-dom";
import { Button, Content, DateInput, FormFields, usePathFactory, useTranslator } from "@sia/style-guide";
import Page from "../../../Page";
import { useContext, useEffect, useState } from "react";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import GlobalContext from "contexts/GlobalContext";

const BachelorPage = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const history = useHistory();
  const { user, wizardSession } = useContext(GlobalContext);
  const [bachelorDate, setBachelorDate] = useState("");
  const [dateError, setDateError] = useState(null);

  useEffect(() => {
    let userId = user.siaId;
    webPlatformAdapter.getWizardSession(userId, (session) => {
      let bachelorGraduationDate = session?.bachelorGraduationDate;
      if (bachelorGraduationDate) {
        setBachelorDate(bachelorGraduationDate);
      }
    });
  }, [user.siaId]);

  return (
    <Page>
      <Content width={"slim"} centeredTitle={true} centeredTexts={true}>
        <div className="bachelor-page">
          <h1 className="productive-heading-04 branch-page__heading">{translate("wizard.sia-ways.title")}</h1>
          <FormFields>
            <DateInput
              value={bachelorDate}
              label={translate("wizard.bachelor.input.label")}
              id={"master-date"}
              onChange={(event, value, error) => {
                setBachelorDate(value);
                setDateError(error);
              }}
              className={"master-page__input"}
              invalidPatternText={translate("form.input.error.invalid.with-example", { example: "d.m.yyyy" })}
              invalidText={dateError}
            />
          </FormFields>
          <p>
            <Button
              onClick={() => {
                if (!bachelorDate) {
                  return;
                }
                let sessionObject = { ...wizardSession, bachelorGraduationDate: bachelorDate };
                webPlatformAdapter.setWizardSession(user.userId, sessionObject);
                history.push(pathFactory.create("wizard/member-options"));
              }}
            >
              {translate("wizard.sia-ways.next.button.label")}
            </Button>
          </p>
        </div>
      </Content>
    </Page>
  );
};

export default BachelorPage;
